import { decode } from 'jsonwebtoken';
import { JWT_TOKEN } from '../../constants/localStorage';
import { retrieveFromSessionStorage } from '../helpers/sessionStorageHelper';

export const useGetIsImpersonating = () => {
  const jwtToken = retrieveFromSessionStorage(JWT_TOKEN);

  if (jwtToken) {
    const { JwtTokenType } = decode(jwtToken);
    const isSalesAssisted = JwtTokenType === 'Impersonation';
    return { isSalesAssisted };
  }

  return false;
};
